__turbopack_context__.v({
  "dangerHint": "Form-module__bGzMWa__dangerHint",
  "formItemSpacing": "Form-module__bGzMWa__formItemSpacing",
  "hintText": "Form-module__bGzMWa__hintText",
  "secondaryHint": "Form-module__bGzMWa__secondaryHint",
});
